import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero */}
      <div className="bg-[#F5F2EE] border-b border-[#1C1C1C]/8">
        <div className="max-w-7xl mx-auto px-8 md:px-14 py-16 md:py-24">
          <nav className="flex items-center gap-2 text-xs text-[#1C1C1C]/35 mb-8">
            <Link to="/" className="hover:text-[#ec3145] transition-colors cursor-pointer">მთავარი</Link>
            <i className="ri-arrow-right-s-line text-[10px]"></i>
            <span className="text-[#1C1C1C]/55">კონფიდენციალურობის პოლიტიკა</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-[#1C1C1C] tracking-tight mb-4">
            კონფიდენციალურობის პოლიტიკა
          </h1>
          <p className="text-[#1C1C1C]/45 text-base md:text-lg max-w-2xl">
            თქვენი პირადი მონაცემების დაცვა ჩვენი პრიორიტეტია. გთხოვთ, ყურადღებით გაეცნოთ ჩვენს პოლიტიკას.
          </p>
          <p className="text-xs text-[#1C1C1C]/25 mt-6">ბოლო განახლება: 27 აპრილი, 2026</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-8 md:px-14 py-16 md:py-24">
        <div className="prose prose-lg max-w-none">
          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">1. ზოგადი ინფორმაცია</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              Phoenix Georgia (შემდგომში "ჩვენ", "კომპანია" ან "Phoenix") პატივს სცემს თქვენს კონფიდენციალურობას და მკაცრად იცავს თქვენს პირად მონაცემებს. ეს პოლიტიკა აღწერს, თუ როგორ ვაგროვებთ, ვიყენებთ, ვინახავთ და ვიცავთ თქვენს ინფორმაციას, როდესაც იყენებთ ჩვენს ვებსაიტს (phoenix.ge) და ჩვენს მომსახურებებს.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              ჩვენი კომპანია მოქმედებს საქართველოს კანონმდებლობის შესაბამისად, მათ შორის "პერსონალურ მონაცემთა დაცვის შესახებ" საქართველოს კანონის (N 473) მოთხოვნების დაცვით.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">2. რა მონაცემებს ვაგროვებთ</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              ჩვენ შესაძლოა შევაგროვოთ შემდეგი ტიპის ინფორმაცია:
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">საკონტაქტო ინფორმაცია:</strong> სახელი, გვარი, ტელეფონის ნომერი, ელექტრონული ფოსტის მისამართი, კომპანიის დასახელება.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">ტექნიკური მონაცემები:</strong> IP მისამართი, ბრაუზერის ტიპი, მოწყობილობის ტიპი, ოპერაციული სისტემა, ვიზიტის თარიღი და დრო.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">ქცევითი მონაცემები:</strong> ვებსაიტზე მოქმედებები, გვერდები რომლებსაც სტუმრობთ, დრო რომელსაც ატარებთ საიტზე, დაწკაპუნებები და ნავიგაცია.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">კომუნიკაციის მონაცემები:</strong> თქვენი შეკითხვები, კომენტარები, გამოხმაურებები და კონსულტაციის მოთხოვნები.</span>
              </li>
            </ul>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">3. მონაცემთა გამოყენების მიზნები</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              თქვენი მონაცემები გამოიყენება შემდეგი მიზნებისთვის:
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>პროდუქტებისა და მომსახურებების მიწოდება და მართვა</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>თქვენს შეკითხვებზე და მოთხოვნებზე პასუხის გაცემა</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>კონსულტაციისა და ტექნიკური მხარდაჭერის გაწევა</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>ვებსაიტის ფუნქციონირების გაუმჯობესება და მომხმარებლის გამოცდილების ოპტიმიზაცია</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span>კანონიერი ვალდებულებების შესრულება</span>
              </li>
            </ul>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">4. მონაცემთა შენახვა და დაცვა</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              თქვენი პირადი მონაცემები ინახება უსაფრთხო სერვერებზე, რომლებიც აღჭურვილია თანამედროვე უსაფრთხოების ტექნოლოგიებით. ჩვენ ვიყენებთ SSL/TLS დაშიფვრას მონაცემთა გადაცემის დროს და ვახორციელებთ რეგულარულ უსაფრთხოების აუდიტებს.
            </p>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              მონაცემები ინახება მხოლოდ იმ პერიოდის განმავლობაში, რომელიც საჭიროა მათი შეგროვების მიზნის მისაღწევად, ან როგორც კანონმდებლობა მოითხოვს. ჩვენ არ ვყიდით, ვაქირავებთ და არ ვაზიარებთ თქვენს პირად მონაცემებს მესამე მხარეებთან მარკეტინგული მიზნებისთვის.
            </p>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">5. თქვენი უფლებები</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              საქართველოს კანონმდებლობის შესაბამისად, თქვენ გაქვთ შემდეგი უფლებები:
            </p>
            <ul className="space-y-3 text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed">
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">ინფორმაციის უფლება:</strong> მოითხოვოთ ინფორმაცია თქვენი მონაცემების დამუშავების შესახებ.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">წვდომის უფლება:</strong> მოითხოვოთ თქვენი პირადი მონაცემების ასლი.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">შესწორების უფლება:</strong> მოითხოვოთ არასწორი ან არაზუსტი მონაცემების გასწორება.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">წაშლის უფლება:</strong> მოითხოვოთ თქვენი მონაცემების წაშლა ("დავიწყების უფლება").</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-1.5 h-1.5 rounded-full bg-[#ec3145] mt-2 flex-shrink-0"></span>
                <span><strong className="text-[#1C1C1C]/75">შეზღუდვის უფლება:</strong> მოითხოვოთ მონაცემთა დამუშავების შეჩერება.</span>
              </li>
            </ul>
          </section>

          <section className="mb-14">
            <h2 className="text-xl md:text-2xl font-bold text-[#1C1C1C] mb-5">6. კონტაქტი</h2>
            <p className="text-[#1C1C1C]/55 text-sm md:text-base leading-relaxed mb-4">
              თუ გაქვთ კითხვები ან შეშფოთება თქვენი კონფიდენციალურობის შესახებ, გთხოვთ დაგვიკავშირდეთ:
            </p>
            <div className="bg-[#F5F2EE] rounded-lg p-6 md:p-8">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ელფოსტა</p>
                    <a href="mailto:info@phoenix.ge" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">info@phoenix.ge</a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-phone-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">ტელეფონი</p>
                    <a href="tel:+995599872020" className="text-sm text-[#1C1C1C]/70 hover:text-[#ec3145] transition-colors cursor-pointer">+995 599 87 20 20</a>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">მისამართი</p>
                    <p className="text-sm text-[#1C1C1C]/70">გელოვანის ქ. N13, თბილისი</p>
                  </div>
                </div>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-[#ec3145]"></i>
                  </div>
                  <div>
                    <p className="text-xs text-[#1C1C1C]/35 mb-0.5">სამუშაო საათები</p>
                    <p className="text-sm text-[#1C1C1C]/70">ორშ–შაბ: 09:30–19:30</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}